import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { compose } from "underscore";
import {
  AlertInfo,
  Alert,
  DefaultLoader,
  FooterSaveInvest,
  GiveawayAlert,
  StartedCard,
} from "../../components";
import { icons, images } from "../../constants";
import { getNewTokenSuccess } from "../../containers/Authentication/redux/actions";
import { setStep, showError } from "../../globalRedux/actions";
import { sendLogError } from "../../utils/api";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { getAuthTNG } from "../../utils/getAuthTNG";
import { useGiveawayAlert, useHandleDuplicate } from "../../utils/hooks";
import {
  checkEcddStatus,
  getRetirementFunds,
  updateProfile,
  resetData,
} from "../redux/action";
import {
  GET_STARTED,
  OLD_USER,
  ONBOARDING_USER,
  ONBOARDING,
  NEW_USER,
} from "../redux/constant";
import {
  getMaxRetirementYear,
  getMinRetirementYear,
  getProjectedReturn,
  getProjectedReturnInvest,
  getRetirementCardInfo,
  getRetirementMinAmount,
  getTotalUnitFunds,
  setProfileInfoV2,
  setStepStarted,
  updateCustomerDuplicate,
} from "./redux/actions";
import { ENV_INVEST, ENV_RETIREMENT, ENV_SAVE } from "./redux/constant";
import { checkProfileRedirect, createPayload } from "./utils";
import "./styles.scss";
import { calculateAgeFromYear } from "../../utils/calculateAgeFromBirthOfYear";
import { getSessionStorage, setSessionStorage } from "../../utils/session";
import {
  isRebatePromoActive,
  isRetireEasyPromoActive,
  GIVEAWAY_SURFACES,
  isGiveawayPromoActive,
  isGotitanPromoActive,
} from "../../utils/constants";
import moment from "moment";
/**
 * ! sChange to conditionanl Component after ready to use version one/two
 */
export const COMPLETE_PAYLOAD = "COMPLETE_PAYLOAD";
const errorMessageDefault =
  "We are facing some technical issue, we're sorry for the inconvenience.";

const liveAgentWhatsappNumber = process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER?.trim();

function GetStartedV2(props) {
  const {
    saveProjectedReturnValue,
    saveInceptionDate,
    getProjectedReturn,
    setStepStarted,
    history,
    checkEcddStatus,
    ecddStatus,
    setStep,
    getStartedLoading,
    loading,
    getTotalUnitFunds,
    totalUnitFunds,
    startedStep,
    getProjectedReturnInvest,
    investProjectedReturnValue,
    investInceptionDate,
    investGetStartedLoading,
    updateCustomerDuplicate,
    updateCustomerDuplicateLoading,
    showError,
    getNewTokenSuccess,
    fundsUnitloading,
    updateProfile,
    resetData,
    retirementMinAmount,
    retirementInceptiondate,
    retirementProjectedReturn,
    getRetirementMinAmountLoading,
    getRetirementCardInfoLoading,
    getRetirementCardInfo,
    getRetirementMinAmount,
    getMinRetirementYear,
    getMaxRetirementYear,
    minRetirementYear,
    maxRetirementYear,
    getMinRetirementYearLoading,
    getMaxRetirementYearLoading,
    getRetirementFunds,
    retirementFunds,
    loadingRetirementFunds,
  } = props;

  const [nricAlert, setOpenNricAlert] = useState(false);
  const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);
  const [pepAlert, setPEPalert] = useState(false);
  //const { notifyGiveaway, dismissGiveaway } = useGiveawayAlert();
  const { duplicated, copywriting, handleDuplicate } = useHandleDuplicate(
    updateCustomerDuplicate,
    getNewTokenSuccess
  );
  const [isMinor, setIsMinor] = useState(false);
  const [
    unEligibleForRetirementAgeAlert,
    setUnEligibleForRetirementAgeAlert,
  ] = useState(false);

  const list = [
    {
      name: "Info",
      link: "https://www.principal.com.my/en/invest-via-tngewallet",
      action: "url",
    },
    {
      name: "About us",
      link: "https://www.principal.com.my/en/aboutus/mv",
      action: "url",
    },
    {
      name: "FAQ",
      link: "https://www.principal.com.my/en/invest-va-tngewallet-faq",
      action: "url",
    },
    {
      name: "Contact Us",
      link: `https://wa.me/${liveAgentWhatsappNumber}`,
      action: "navigate",
    },
  ];

  const openTNGTnC = () => {
    dataLayerGTM("click_tag", "Click", "Link", `Get Started - T&C button`);
    window.my.navigateTo({
      url:
        "/pages/link/link?url=" +
        encodeURIComponent(
          "https://www.principal.com.my/en/privacy-notice-my/mv"
        ),
    });
  };

  const manipulateLogError = (amlError, ecddError) => {
    let amlLogError;

    if (amlError && amlError.amlHistory && amlError.amlHistory.length > 0) {
      amlLogError = amlError.amlHistory[0].amlSts;
    }

    let errorPayload = {
      page: "Get Started",
      path: "/",
      aml: amlLogError || "Not Found",
      ecdd: ecddError || "Not Found",
    };

    sendLogError(errorPayload);
  };

  const redirectAction = async profile => {
    if (
      profile === null ||
      Boolean(duplicated.idNo || duplicated.mobileNo || duplicated.name)
    ) {
      return;
    }

    const fullYear = profile.dob.split("-")[0];
    const userAge = calculateAgeFromYear(fullYear);

    const isUserNotPassedThePRSAgeRequirement = userAge < 19 || userAge > 53;
    const isDOBUserIsNotInRange =
      +fullYear <= +maxRetirementYear && +fullYear >= +minRetirementYear;

    // 1. user not passed the age requirement
    // 2. user passed the age requirement but not passed the year of birth requirement
    // 3. user not passed the year of birth requirement
    if (
      startedStep === ENV_RETIREMENT &&
      Array.isArray(retirementFunds) &&
      retirementFunds.length === 0 &&
      (isUserNotPassedThePRSAgeRequirement ||
        (!isUserNotPassedThePRSAgeRequirement && isDOBUserIsNotInRange) ||
        isDOBUserIsNotInRange)
    ) {
      setUnEligibleForRetirementAgeAlert(true);
      return;
    }

    let directTo = checkProfileRedirect(profile);

    if (typeof directTo === "object" && !Array.isArray(directTo)) {
      manipulateLogError(profile, ecddStatus);
      return;
    }

    // resetting master id with new user profile
    await setSessionStorage("masterId", profile.masterId);

    switch (directTo) {
      case "DIRECT_ONBOARDING":
        localStorage.setItem("isNewUser", ONBOARDING_USER);
        await setSessionStorage("isNewUser", ONBOARDING_USER); // Add TnG storage
        history.push("/onBoarding/form-step-one");
        break;
      case "DIRECT_DASHBOARD":
        localStorage.setItem("isNewUser", OLD_USER);
        await setSessionStorage("isNewUser", OLD_USER); // Add TnG storage
        // Force the customer to review/acknowledge their profile first.
        history.push(
          profile.showProfileUpdatePrompt ? "/profile/info" : "/dashboard"
        );
        break;
      case COMPLETE_PAYLOAD:
        if ("pepFlag" in profile && profile.pepFlag === "1") {
          setPEPalert(true);
          break;
        }
        const payload = createPayload(profile);

        if (typeof payload === "string" && payload === "invalid-email") {
          history.push("/onBoarding/form-step-one", {
            invalidEmail: true,
          });
          break;
        }

        if (!isUpdatingProfile) {
          setIsUpdatingProfile(true);
          updateProfile(
            {
              payloadData: payload,
              from: ONBOARDING,
            },
            () => setIsUpdatingProfile(false)
          );
        }
        // Store user status after successful profile update
        localStorage.setItem("isNewUser", OLD_USER);
        await setSessionStorage("isNewUser", OLD_USER);
        break;
      default:
        manipulateLogError(profile, ecddStatus);
        break;
    }
  };

  useEffect(() => {
    getProjectedReturn();
    getTotalUnitFunds("MPInvest");
    getProjectedReturnInvest();
    getRetirementCardInfo();
    getRetirementMinAmount();
    getMinRetirementYear();
    getMaxRetirementYear();
  }, []);

  useEffect(() => {
    setStep("/");

    window.eventManager.on("NRIC_VALIDATION", () => {
      setOpenNricAlert(true);
    });

    window.eventManager.on(
      "CUSTOMER_PRODUCT_TYPE",
      ({ productType, profile }) => {
        // need to pass profile/masterId to ensure user data that's used in the api call available
        // because the redux store haven't synchronize the data at this moment
        // after api call completed redux will synchronize the data and the store will be up to date
        checkEcddStatus(profile?.masterId);

        const redirect = { callback: redirectAction, profile };

        const tabs = {
          ENV_SAVE: {
            id: 1,
            name: "Save",
          },
          ENV_INVEST: {
            id: 2,
            name: "Invest",
          },
          ENV_RETIREMENT: {
            id: 3,
            name: "Retirement",
          },
        };

        localStorage.setItem("currentTab", JSON.stringify(tabs[productType]));
        setStepStarted(productType);

        if (productType === ENV_RETIREMENT) {
          getRetirementFunds(redirect);
        } else {
          redirectAction(profile);
        }
      }
    );

    window.eventManager.on("AGE_VALIDATION", productType => {
      if (productType === ENV_RETIREMENT) {
        setUnEligibleForRetirementAgeAlert(true);
      } else {
        setIsMinor(true);
      }
    });

    window.eventManager.on("TRIGGER_ERROR", res => {
      if (process.env.REACT_APP_ENV.trim() === "production") {
        showError(errorMessageDefault);
      } else {
        showError(res);
      }
    });

    return () => window.eventManager.clearEvents();
  }, []);

  /**
   * @event GetStarted click event
   * @function getAuthCode from mini program
   * @event Save user status into local storage as New User
   * @event Navigate to create goal screen
   */

  const handleGetStarted = productType => {
    getAuthTNG(GET_STARTED, productType);
    dataLayerGTM("click_tag", "Click", "Button", "Get Started Button");
  };

  /** @constant isNewUser to be used as conditional rendering */
  const [isNewUser, setIsNewUser] = useState(null);

  useEffect(() => {
    const checkUserStatus = async () => {
      // Check TnG storage first
      let userStatus = await getSessionStorage("isNewUser");
      if (!userStatus) {
        userStatus = NEW_USER;
      }
      setIsNewUser(userStatus);
    };

    checkUserStatus();
  }, []);

  // Show loading while checking user status
  if (isNewUser === null) {
    return <DefaultLoader />;
  }

  return (
    <>
      {isNewUser === OLD_USER ? (
        <Redirect to="/dashboard" />
      ) : (
        <div className="invest-save-container">
          {(loading ||
            getStartedLoading ||
            investGetStartedLoading ||
            fundsUnitloading ||
            getRetirementMinAmountLoading ||
            getRetirementCardInfoLoading ||
            getMinRetirementYearLoading ||
            getMaxRetirementYearLoading ||
            loadingRetirementFunds) && <DefaultLoader />}
          <AlertInfo
            handleAction={() => {
              setIsMinor(false);
            }}
            description="Age restriction: User must be 18 years old or older"
            isOpen={isMinor}
            isTimeout
          />
          <Alert
            title="Account doesn’t meet requirement"
            description="So sorry, your account doesn’t meet our requirement."
            isOpen={pepAlert}
            isCS="https://principal.com.my"
            isCancel={false}
            handleAction={() => {
              resetData();
              setPEPalert(false);
            }}
          />
          <Alert
            title="Oops... You are not eligible to invest in this fund"
            description="Please contact our Customer Care Centre for assistance."
            isOpen={unEligibleForRetirementAgeAlert}
            isCancel={false}
            btnTxt="Back"
            handleAction={() => {
              setUnEligibleForRetirementAgeAlert(false);
            }}
            handleCancel={() => {
              setUnEligibleForRetirementAgeAlert(false);
            }}
            withCloseButton
            additionalContent={
              <p
                style={{
                  color: "#1278CC",
                  fontSize: "16px",
                  fontWeight: 400,
                  width: "100%",
                  textAlign: "center",
                  cursor: "pointer",
                  display: "inline-block",
                  marginBottom: "24px",
                }}
                onClick={() => {
                  window.my.call("openAppLink", {
                    url: `https://wa.me/${liveAgentWhatsappNumber}`,
                  });
                }}
              >
                Chat with Customer Service
              </p>
            }
            submitButtonStyle={{ marginTop: "2rem" }}
          />
          <Alert
            title="Invalid ID format"
            description="We encountered an issue with the ID format that was automatically captured. "
            isOpen={nricAlert}
            isCS="https://principal.com.my"
            isCancel={false}
            btnTxt="Chat with us on WhatsApp"
            handleAction={() => {
              setOpenNricAlert(false);
              window.my.call("openAppLink", {
                url: `https://wa.me/${liveAgentWhatsappNumber}`,
              });
            }}
            handleCancel={() => setOpenNricAlert(false)}
            withCloseButton
          />
          <Alert
            title={copywriting.heading}
            description={
              <>
                {copywriting.title}
                <br />
                <br />
                {copywriting.description}
                <br />
                <br />
                {copywriting.additionalContext}
                <span
                  style={{
                    marginTop: "1rem",
                    marginBottom: "0.5rem",
                    fontSize: "16px",
                    fontWeight: 700,
                    display: "block",
                  }}
                >
                  {duplicated.name && <>Name: {duplicated.name}</>}
                  {duplicated.mobileNo && (
                    <>
                      {duplicated.name && <br />}
                      Mobile: {duplicated.mobileNo}
                    </>
                  )}
                  {duplicated.idNo && (
                    <>
                      {(duplicated.name || duplicated.mobileNo) && <br />}
                      MyKad: {duplicated.idNo}
                    </>
                  )}
                </span>
              </>
            }
            additionalContent={
              duplicated.type === "tng" && (
                <p
                  style={{
                    color: "#1278CC",
                    fontSize: "16px",
                    fontWeight: 400,
                    width: "100%",
                    textAlign: "center",
                    cursor: "pointer",
                    display: "inline-block",
                    marginBottom: "24px",
                  }}
                  onClick={() => {
                    window.my.navigateTo({
                      url:
                        "/pages/link/link?url=" +
                        encodeURIComponent(
                          "https://support.tngdigital.com.my/hc/en-my/requests/new?ticket_form_id=360001558914"
                        ),
                    });
                  }}
                >
                  Contact Touch ‘n Go Customer Service
                </p>
              )
            }
            isOpen={Boolean(
              duplicated.idNo || duplicated.mobileNo || duplicated.name
            )}
            handleAction={handleDuplicate}
            btnTxt={
              updateCustomerDuplicateLoading
                ? "Please wait..."
                : { mp: "Contact Customer Service", tng: "Confirm" }[
                    duplicated.type
                  ]
            }
            submitButtonDisabled={updateCustomerDuplicateLoading}
            titleStyle={{ fontWeight: 900 }}
          />
          {/* {isGiveawayPromoActive(GIVEAWAY_SURFACES.GET_STARTED) && (
            <GiveawayAlert
              isOpen={notifyGiveaway}
              handleClose={dismissGiveaway}
              sourceImg="retireeasy2026"
            />
          )} */}

          <div className="invest-save-container__first">
            <div className="invest-save-container__first__header">
              <div>
                <img src={images.principalSvg} alt="principal-logo" />
              </div>
              <div>
                <span>In partnership with</span>
                <div>
                  <img src={images.tngdSvg} alt="tngd-logo" />
                </div>
              </div>
            </div>
            <StartedCard
              color={"#084C95"}
              headerTitle={"Invest"}
              // additionalTitles="Promo"
              {...(isGotitanPromoActive()
                ? { additionalTitles: "50%" }
                : {})}
              text1="Access diversified local and global opportunities"
              text2="Funds based on different risk appetite"
              text3="Best Online & Mobile Platform by Alpha Southeast Asia Awards 2026"
              headerDesc={`${totalUnitFunds} Unit Trust Funds`}
              percent={investProjectedReturnValue}
              //inceptionDate={investInceptionDate}
              investFrom={"RM10"}
              firstIcon={icons.globe}
              secondIcon={images.userCheck}
              thirdIcon={images.award}
              percentColor={"#DDF75B"}
              setAction={() => {
                setStepStarted(ENV_INVEST);
                dataLayerGTM(
                  "click_tag",
                  "Click",
                  "Button",
                  `Get Started - Invest - Next button`
                );
                handleGetStarted(ENV_INVEST);
              }}
            />

            <StartedCard
              color={"#1381A3"}
              headerTitle={"Retire"}
              headerDesc={"Private Retirement Scheme"}
              percent={retirementProjectedReturn}
              investFrom={`RM${retirementMinAmount}`}
              additionalTitles={isRetireEasyPromoActive() ? "Bonus" : undefined}
              // additionalTitles="Promo"
              text1="Enjoy up to RM3,000 in annual tax relief"
              text2="Easy investing with automatic fund selection based on your year of birth"
              //inceptionDate={retirementInceptiondate}
              firstIcon={icons.checkCirclePrimary}
              secondIcon={icons.auto}
              percentColor={"#DDF75B"}
              setAction={() => {
                setStepStarted(ENV_RETIREMENT);
                dataLayerGTM(
                  "click_tag",
                  "Click",
                  "Button",
                  `Get Started - Retirement - Next button`
                );
                handleGetStarted(ENV_RETIREMENT);
              }}
            />

            <StartedCard
              color={"#1278CC"}
              headerTitle={"Save"}
              text1={"No lock in period & Shariah-compliant"}
              text2={"Goal-based investing for your financial goals"}
              headerDesc="Principal Islamic Money Market Fund"
              /*risk={"Low risk"}*/
              percent={saveProjectedReturnValue}
              //inceptionDate={saveInceptionDate}
              investFrom={"RM10"}
              firstIcon={images.checkCircle}
              secondIcon={icons.crosshair}
              thirdIcon={images.award}
              percentColor={"#DDF75B"}
              setAction={() => {
                setStepStarted(ENV_SAVE);
                dataLayerGTM(
                  "click_tag",
                  "Click",
                  "Button",
                  `Get Started - Save - Next button`
                );
                handleGetStarted(ENV_SAVE);
              }}
            />

            <div
              className="TnC-container__first__footer"
              style={{ margin: "24px 0" }}
            >
              <p>
                Returns shown above represent performance as of <br />
                <b>{moment(investInceptionDate).format("D MMM YYYY")}</b>
              </p>
            </div>

            <div className="TnC-getStarted" style={{ margin: "24px 0" }}>
              <p>
                By proceeding, you agree to share your Personal Data with
                Principal subjected to the following{" "}
                <span onClick={openTNGTnC}>Terms & Conditions.</span>
              </p>
            </div>
          </div>

          <FooterSaveInvest list={list}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "1rem",
              }}
            >
              <img src={icons.shieldIcon} alt="shield icon" />
              <p style={{ marginTop: "2px", marginLeft: "0.35rem" }}>
                Regulated by the Securities Commission Malaysia
              </p>
            </div>
          </FooterSaveInvest>
        </div>
      )}
    </>
  );
}

const withConnect = connect(
  state => ({
    startedStep: state.getStartedReducer.startedStep,
    totalUnitFunds: state.getStartedReducer.totalUnitFunds.itemCount,
    profile: state.goal.profile,
    loading: state.goal.loading,
    saveProjectedReturnValue: state.getStartedReducer.saveProjectedReturnValue,
    saveInceptionDate: state.getStartedReducer.saveInceptionDate,
    getStartedLoading: state.getStartedReducer.getStartedLoading,
    ecddStatus: state.goal.ecddStatus,
    investGetStartedLoading: state.getStartedReducer.investGetStartedLoading,
    investProjectedReturnValue:
      state.getStartedReducer.investProjectedReturnValue,
    investInceptionDate: state.getStartedReducer.investInceptionDate,
    updateCustomerDuplicateLoading:
      state.getStartedReducer.updateCustomerDuplicateLoading,
    ...state.custinvestReducer,
    fundsUnitloading: state.getStartedReducer.fundsUnitloading,
    retirementMinAmount: state.getStartedReducer.retirementMinAmount,
    getRetirementMinAmountLoading:
      state.getStartedReducer.getRetirementMinAmountLoading,
    retirementProjectedReturn:
      state.getStartedReducer.retirementProjectedReturn,
    retirementInceptiondate: state.getStartedReducer.retirementInceptiondate,
    getRetirementCardInfoLoading:
      state.getStartedReducer.getRetirementCardInfoLoading,
    getMaxRetirementYearLoading:
      state.getStartedReducer.getMaxRetirementYearLoading,
    getMinRetirementYearLoading:
      state.getStartedReducer.getMinRetirementYearLoading,
    maxRetirementYear: state.getStartedReducer.maxRetirementYear,
    minRetirementYear: state.getStartedReducer.minRetirementYear,
    retirementFunds: state.goal.retirementFunds,
    loadingRetirementFunds: state.goal.loadingRetirementFunds,
  }),
  {
    setProfileInfoV2,
    getProjectedReturn, //API
    setStepStarted,
    checkEcddStatus, //API
    setStep,
    getTotalUnitFunds, //API
    getProjectedReturnInvest, //API,
    updateCustomerDuplicate, //API
    showError,
    getNewTokenSuccess,
    updateProfile,
    resetData,
    getRetirementMinAmount,
    getRetirementCardInfo,
    getMinRetirementYear,
    getMaxRetirementYear,
    getRetirementFunds,
  }
);

export default compose(
  withRouter,
  withConnect
)(GetStartedV2);
